import autenticacao from './autenticacao/index'

// eslint-disable-next-line
export const autenticacaoStore = autenticacao